import { motion, AnimatePresence } from "framer-motion";
import { X, Sparkle, Wind } from "@phosphor-icons/react";

const IngredientDialog = ({ herb, onClose }) => (
  <AnimatePresence>
    {herb && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-8"
        data-testid="ingredient-dialog-overlay"
        onClick={onClose}
      >
        <div data-testid="ingredient-dialog-backdrop" onClick={onClose} className="absolute inset-0 bg-[#041a0f]/70 backdrop-blur-sm" />
        <motion.div
          initial={{ opacity: 0, y: 40, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.97 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          onClick={(e) => e.stopPropagation()}
          data-testid="ingredient-dialog"
          className="glass-panel relative w-full max-w-2xl rounded-2xl overflow-hidden shadow-2xl shadow-black/50"
        >
          <button
            onClick={onClose}
            data-testid="ingredient-dialog-close"
            aria-label="Close"
            className="absolute top-4 right-4 z-10 rounded-full bg-[#0B3B24]/10 hover:bg-[#0B3B24]/20 p-2 text-[#0B3B24] transition-colors duration-300"
          >
            <X size={18} weight="bold" />
          </button>

          <div className="grid grid-cols-1 sm:grid-cols-5">
            <div className="sm:col-span-2 relative min-h-[200px] sm:min-h-full">
              <img src={herb.image} alt={herb.name} className="absolute inset-0 w-full h-full object-cover" />
            </div>
            <div className="sm:col-span-3 p-8 sm:p-10">
              <span className="text-[10px] uppercase tracking-[0.3em] text-[#C5A880] font-medium">
                Ingredient Intelligence
              </span>
              <h3 data-testid="ingredient-dialog-name" className="mt-3 font-display text-3xl sm:text-4xl text-[#0B3B24] tracking-tight">
                {herb.name}
              </h3>
              <p className="font-display italic text-[#0B3B24]/55 text-lg">{herb.latin}</p>
              <p className="mt-1 text-xs uppercase tracking-[0.2em] text-[#0B3B24]/60">{herb.tagline}</p>

              <div className="mt-6 space-y-5">
                <div className="flex gap-3">
                  <Sparkle size={20} weight="duotone" className="text-[#C5A880] shrink-0 mt-0.5" />
                  <div>
                    <p className="text-xs uppercase tracking-[0.15em] text-[#0B3B24]/50 mb-1">Ayurvedic Benefit</p>
                    <p className="text-sm text-[#0B3B24]/85 leading-relaxed">{herb.benefit}</p>
                  </div>
                </div>
                <div className="flex gap-3">
                  <Wind size={20} weight="duotone" className="text-[#C5A880] shrink-0 mt-0.5" />
                  <div>
                    <p className="text-xs uppercase tracking-[0.15em] text-[#0B3B24]/50 mb-1">In the Ritual</p>
                    <p className="text-sm text-[#0B3B24]/85 leading-relaxed">{herb.role}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default IngredientDialog;
